import axios from "axios";
import { API_URL } from "../../constants";

export const GetBasicEvent = async (eventId,ApiStatus) => {
    ApiStatus({ isLoader: true, isError: false, data: null });
    const token = localStorage.getItem('LOGIN_TOKEN');

    try {
        let res = await axios.get(API_URL + "event/basic/"+eventId, {
            headers: {
                'Authorization': "Bearer " + token,
            }
        });
        ApiStatus({ isLoader: false, isError: false, data: res.data });
    } catch (err) {
        ApiStatus({ isLoader: false, isError: true, data: null });
    }

}